<template>
  <img
    class="rounded-circle shadow select-none"
    :width="width_img"
    :height="height_img"
    :src="avatar_arr[id_avatar]"
    @click="AvaClick"
  />
</template>

<script>
import i_0 from "@/assets/image/ava_0.png";
import i_1 from "@/assets/image/ava_1.png";
import i_2 from "@/assets/image/ava_2.png";
import i_3 from "@/assets/image/ava_3.png";
import i_4 from "@/assets/image/ava_4.png";
import i_5 from "@/assets/image/ava_5.png";
import i_6 from "@/assets/image/ava_6.png";
import i_7 from "@/assets/image/ava_7.png";
import i_8 from "@/assets/image/ava_8.png";
import i_9 from "@/assets/image/ava_9.png";
export default {
  props: {
    id_avatar: { type: Number, default: 0 },
    width_img: { type: Number, default: 40 },
    height_img: { type: Number, default: 40 }
  },
  data() {
    return {
      avatar_arr: [i_0, i_1, i_2, i_3, i_4, i_5, i_6, i_7, i_8, i_9],
      // :P
      count_click: 0,
      // :)
      locker_ticker: false
    };
  },
  methods: {
    /**
     * :P
     */
    AvaClick() {
      if (this.count_click > 11) this.Action();
      else this.count_click++;

      if (this.count_click <= 1 && !this.locker_ticker) {
        this.locker_ticker = true;
        this.Ticker();
      }
    },
    /**
     * :)
     */
    Ticker() {
      if (this.locker_ticker && this.count_click > 0) {
        this.count_click--;
        setTimeout(this.Ticker, 500);
      } else {
        this.locker_ticker = false;
      }
    },
    /**
     * :D
     */
    Action() {
      this.count_click = 0;
      this.$emit("ultra_click", 9);
    }
  }
};
</script>